var SupportAPIHelper, SupportStepTwoCMSModel,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

SupportAPIHelper = require('../helpers/API');

SupportStepTwoCMSModel = (function() {
  function SupportStepTwoCMSModel(options) {
    this.helpContentError = bind(this.helpContentError, this);
    this.helpContentSuccess = bind(this.helpContentSuccess, this);
    this.mainView = options != null ? options.mainView : void 0;
  }

  SupportStepTwoCMSModel.prototype.fetchHelpContent = function(tagLinesBase, defaultTagLine) {
    var cb, data, get_flexible_content_api_timeout_in_milliseconds, urls;
    get_flexible_content_api_timeout_in_milliseconds = 60000;
    data = this.getRequestParams(tagLinesBase, defaultTagLine);
    urls = this.getHelpContentPaths();
    cb = (function(_this) {
      return function(results) {
        return _this.helpContentCb(results);
      };
    })(this);
    return this.contentRequests = SupportAPIHelper.parallel(urls, data, cb, false, "t_ic", get_flexible_content_api_timeout_in_milliseconds);
  };

  SupportStepTwoCMSModel.prototype.getRequestParams = function(tagLinesBase, defaultTagLine) {
    var contentParams, priorityTaglines, stepThreeParams, tagLines;
    this.requestParams = [];
    tagLines = {
      baseTagline: tagLinesBase,
      defaultTagLine: defaultTagLine
    };
    if (this.arePriorityTaglinesPresent()) {
      priorityTaglines = Groupon.Support.currentOrder.priorityTaglines;
      tagLines["priorityTaglines"] = priorityTaglines;
    }
    stepThreeParams = {
      tagLineData: tagLines,
      type: "flexible_step_three"
    };
    contentParams = {
      tagLineData: tagLines,
      type: "content"
    };
    this.requestParams.push(contentParams, stepThreeParams);
    return this.requestParams;
  };

  SupportStepTwoCMSModel.prototype.getHelpContentPaths = function() {
    var url;
    url = window.SUPPORTBASEURL + "/get_flexible_content?should_display_cms_content=" + experiments.shouldDisplayCMSContentForUS;
    return [url, url];
  };

  SupportStepTwoCMSModel.prototype.helpContentCb = function(results) {
    if (results != null) {
      return this.helpContentSuccess(results);
    } else {
      return this.helpContentError();
    }
  };

  SupportStepTwoCMSModel.prototype.helpContentSuccess = function(results) {
    var content;
    content = this.resolveResponse(results[0]);
    Groupon.Support.ContentModel.flexibleStepThree = this.resolveResponse(results[1]);
    this.setPriorityContentFlags(results[1]);
    Groupon.Support.ContentModel.setContent(content);
    return this.mainView.renderContent(content);
  };

  SupportStepTwoCMSModel.prototype.helpContentError = function() {
    Groupon.Support.ContentModel.flexibleStepThree = null;
    Groupon.Support.ContentModel.setContent(null);
    this.mainView.helpContentLoadError();
    return this.mainView.enableTicketDirectionButton();
  };

  SupportStepTwoCMSModel.prototype.setPriorityContentFlags = function(contents) {
    var responseTagLine;
    if (this.isResponseTaglinePresent(contents)) {
      responseTagLine = contents['responseTagline'];
      this.setIsRefundEligibleFlag(responseTagLine);
      return this.setEscalateToMerchantFlag(responseTagLine);
    } else {
      Groupon.Support.ContentModel.isRefundEligible = false;
      return Groupon.Support.ContentModel.escalateToMerchant = false;
    }
  };

  SupportStepTwoCMSModel.prototype.setIsRefundEligibleFlag = function(responseTagLine) {
    return Groupon.Support.ContentModel.isRefundEligible = this.isRefundEligibleFlexStepThreePresent(responseTagLine);
  };

  SupportStepTwoCMSModel.prototype.setEscalateToMerchantFlag = function(responseTagLine) {
    if (evaluate(Groupon.Support.ContentModel.isRefundEligible)) {
      return Groupon.Support.ContentModel.escalateToMerchant = false;
    } else {
      return Groupon.Support.ContentModel.escalateToMerchant = this.isEscalateToMerchantFlexStepThreePresent(responseTagLine);
    }
  };

  SupportStepTwoCMSModel.prototype.isRefundEligibleFlexStepThreePresent = function(responseTagLine) {
    var ref;
    return evaluate((ref = Groupon.Support.currentOrder) != null ? ref.isRefundEligible : void 0) && this.isTagPresent(responseTagLine, 'cooling_off');
  };

  SupportStepTwoCMSModel.prototype.isEscalateToMerchantFlexStepThreePresent = function(responseTagLine) {
    var ref;
    return evaluate((ref = Groupon.Support.currentOrder) != null ? ref.escalateToMerchant : void 0) && this.isTagPresent(responseTagLine, 'escalate_to_merchant');
  };

  SupportStepTwoCMSModel.prototype.isTagPresent = function(tagLine, tag) {
    return tagLine.includes(tag);
  };

  SupportStepTwoCMSModel.prototype.isResponseTaglinePresent = function(contents) {
    return (contents != null ? contents['responseTagline'] : void 0) != null;
  };

  SupportStepTwoCMSModel.prototype.resolveResponse = function(contents) {
    var responseKey;
    if (!this.isResponseTaglinePresent(contents)) {
      return {};
    }
    responseKey = contents['responseTagline'];
    return contents[responseKey];
  };

  SupportStepTwoCMSModel.prototype.arePriorityTaglinesPresent = function() {
    var ref, ref1;
    return ((ref = Groupon.Support.currentOrder) != null ? (ref1 = ref.priorityTaglines) != null ? ref1.length : void 0 : void 0) > 0;
  };

  return SupportStepTwoCMSModel;

})();

module.exports = SupportStepTwoCMSModel;

//# sourceMappingURL=data:application/json;base64,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
